<div class="p-g-3 active-box">
  <span ><span translate>label_Total</span> {{totalAndActiveCounts.type}}</span>
  <span class="special-count">{{totalAndActiveCounts.total }}</span>
</div>
<!-- <div class="p-g-3 active-box" *ngIf="totalAndActiveCounts.type=='Passenger'">
  <span >
    <span translate>label_on_trips </span> {{totalAndActiveCounts.type}}</span>
  <span class="special-count">{{totalAndActiveCounts.active }} </span>
</div> -->
<div class="p-g-3 active-box" *ngIf="totalAndActiveCounts.type!=='Passenger'">
  <span >
    <span translate>label_active </span> {{totalAndActiveCounts.type}}</span>
  <span class="special-count">{{totalAndActiveCounts.active }} </span>
</div>
